import SAVE_TIMESLICE_RECORDING from '../../graphql/timeslice/saveTimesliceRecording.gql';
import GET_TIMESLICE_RECORDING from '../../graphql/timeslice/getTimesliceRecordingById.gql';
import {apolloClient} from "../../plugins/apollo-client";

const saveTimesliceRecording = (callSid, recording) =>
  apolloClient.mutate({
    mutation: SAVE_TIMESLICE_RECORDING,
    variables: {
      input:  {
        callSid,
        recording
      }
    }
  });

const getTimesliceRecording = (id) =>
  apolloClient.query({
    query: GET_TIMESLICE_RECORDING,
    variables: {
      id
    }
  }).then(({data:{timesliceRecording}}) => timesliceRecording);

export {
  saveTimesliceRecording,
  getTimesliceRecording
}
